// Helpers puros de Trivia usados por HomeScreen.

export function _todayKey() {
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Argentina/Buenos_Aires',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());
    const y = parts.find(p => p.type === 'year').value;
    const m = parts.find(p => p.type === 'month').value;
    const d = parts.find(p => p.type === 'day').value;
    return `${y}-${m}-${d}`;
  } catch {
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const ba = new Date(utc - 3 * 60 * 60000);
    const y = ba.getFullYear();
    const m = String(ba.getMonth() + 1).padStart(2, '0');
    const d = String(ba.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
}

const _TRIVIA_HISTORY_KEY_PREFIX = 'zodiacus_trivia_history_v1:';

function _histKey(uid) {
  const u = (uid && String(uid)) ? String(uid) : 'anon';
  return _TRIVIA_HISTORY_KEY_PREFIX + u;
}

export function _loadTriviaHistory(uid) {
  try { return JSON.parse(localStorage.getItem(_histKey(uid)) || '[]'); } catch { return []; }
}

export function _saveTriviaHistory(uid, arr) {
  try { localStorage.setItem(_histKey(uid), JSON.stringify(arr.slice(-60))); } catch {}
}

export function _computeStreak(history) {
  if (!Array.isArray(history) || history.length === 0) return 0;
  const daysSet = new Set(
    history
      .filter(r => r && typeof r.day === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(r.day))
      .map(r => r.day)
  );
  if (daysSet.size === 0) return 0;

  const latest = [...daysSet].sort().pop();
  const toDate = (key) => {
    const [y, m, d] = key.split('-').map(Number);
    return new Date(y, m - 1, d);
  };
  const toKey = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  let streak = 0;
  let cursor = toDate(latest);
  while (true) {
    const k = toKey(cursor);
    if (daysSet.has(k)) {
      streak += 1;
      cursor.setDate(cursor.getDate() - 1);
    } else {
      break;
    }
  }
  return streak;
}

export function _bestScore(history) {
  let best = 0;
  for (const r of history) best = Math.max(best, Number(r.score || 0));
  return best;
}

export function _mergeRecentIntoLocalHistory(recentArray, uid) {
  try {
    const recent = Array.isArray(recentArray)
      ? recentArray.filter(x => x && x.day && Number(x.score || 0) > 0)
      : [];
    if (!recent.length) return;

    const prev = _loadTriviaHistory(uid);
    const map = new Map();
    for (const r of prev) {
      if (r && r.day) map.set(String(r.day), { ...r });
    }
    for (const r of recent) {
      const key = String(r.day);
      const score = Number(r.score || 0);
      const total = Number(r.total || 3);
      if (!map.has(key)) {
        map.set(key, { day: key, score, total, ts: Date.now() });
      }
    }
    const next = Array.from(map.values()).sort((a, b) => String(a.day).localeCompare(String(b.day)));
    _saveTriviaHistory(uid, next);
  } catch {}
}

export function _computeStreakFromDays(days) {
  if (!Array.isArray(days) || days.length === 0) return 0;
  const keys = [...new Set(days.filter(Boolean))]
    .filter(k => /\d{4}-\d{2}-\d{2}/.test(String(k)))
    .sort();
  if (keys.length === 0) return 0;

  const toDate = (key) => {
    const [y, m, d] = String(key).split('-').map(Number);
    return new Date(y, m - 1, d);
  };
  const toKey = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  let streak = 0;
  const set = new Set(keys);
  let cursor = toDate(keys[keys.length - 1]);
  while (true) {
    const k = toKey(cursor);
    if (set.has(k)) {
      streak += 1;
      cursor.setDate(cursor.getDate() - 1);
    } else {
      break;
    }
  }
  return streak;
}
